<template>
    <div
        class="entity-element"
        :style="backgroundImage"
        @mouseover="hover = true"
        @mouseleave="hover = false"
        @click="selectEntity"
    >
        <img class="entity-logo" :src="entity.logo">
        <ns-loader
            :to-load="toLoad"
            :custom-scope="entityScope"
            class="full-size"
            @dataFetched="onDataFetched"
        >
            <div slot="loader" class="flex-center">
                <loading-template slot="loading"></loading-template>
            </div>
            <div slot="content" class="feed-info-container full-size">
                <div class="feed-info">
                    <div>running feeds</div>
                    <div class="feed-data">
                        {{ runningFeeds }}
                    </div>
                </div>
                <div class="feed-info">
                    <div>available feeds</div>
                    <div class="feed-data">
                        {{ availableFeeds }}
                    </div>
                </div>
                <div class="feed-info">
                    <div style="margin-bottom: 24px;">next feed <template v-if="nextFeedStartDateIsValid">begins in</template></div>
                    <div class="feed-data">
                        <next-comming-feed :targetDate="nextFeedStartDate"></next-comming-feed>
                    </div>
                </div>
            </div>
        </ns-loader>
    </div>
</template>

<script>
import moment from 'moment';
import { NextCommingFeed } from 'gcmcn-common';
import { LoadingTemplate } from 'gcmcn-common';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
export default {

    components: {
        NextCommingFeed,
        LoadingTemplate,
        NsLoader,
    },

    props: {
        entity: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            hover: false,
            feeds: [],
            broadcastRights: [],
            toLoad: [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        status__in: 'AVAILABLE,PENDING,RUNNING,STARTING,PREPARING',
                        archived: false,
                    }
                },
                {
                    name: 'broadcastRights',
                    model: 'broadcastRights',
                    filters: {
                        revoked: false,
                        archived: false,
                    }
                },
            ],
        };
    },

    computed: {
        backgroundImage (){
            if(this.hover){
                return {
                    background: `url(${this.entity.image})`
                };
            }else{
                return {
                    background: `linear-gradient(180deg, rgba(17, 17, 17, 0) -167.11%, rgba(17, 17, 17, 0.481482) -83.81%, #111111 112.37%), url(${this.entity.image})`
                };
            }
        },

        nextFeedStartDateIsValid(){
            if(this.nextFeedStartDate === null || moment.utc(this.nextFeedStartDate).isBefore(moment.utc())){
                return false;
            }
            return true;
        },

        feedsWithRight (){
            return this.feeds.filter((feed) => {
                return this.broadcastRights.find((br) => {
                    return br.feed_uid === feed.uid;
                });
            });
        },
        runningFeeds (){
            return this.feedsWithRight.sort((a, b) => {
                return new Date(a.confirmed ? a.confirmed_start_date : a.start_date) -
                new Date(b.confirmed ? b.confirmed_start_date : b.start_date) ;
            }).filter((feed) => feed.status === 'RUNNING').length;
        },
        availableFeeds (){
            return this.feedsWithRight.sort((a, b) => {
                return new Date(a.confirmed ? a.confirmed_start_date : a.start_date) -
                new Date(b.confirmed ? b.confirmed_start_date : b.start_date) ;
            }).filter((feed) => ['AVAILABLE', 'PREPARING', 'STARTING'].includes(feed.status)).length;
        },

        nextFeedStartDate (){
            return this.$store.getters.nextFeedStartDate(this.feedsWithRight);
        },

        entityScope (){
            return { 'X-Entity-Uid': this.entity.uid};
        },
    },

    mounted (){

    },

    methods: {
        selectEntity (){
            // set current entity and navigate to full-view
            this.$store.commit('SET_CURRENT_ENTITY', this.entity);
            this.$store.dispatch('setScope', {'X-Entity-Uid': this.entity.uid});
        },

        onDataFetched (res){
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'broadcastRights', res.broadcastRights);
        },
    },
};
</script>

<style lang="scss">
    .entity-element{
        cursor: pointer;
        width: 100%;
        max-width: 680px;
        height: 190px;
        padding: 25px 0 25px 30px;
        margin-bottom: 20px;
        border-radius: 5px;
        background-repeat: no-repeat;
        display: flex;
        transition: all .5s;

        &:hover{
            .feed-info-container{
                opacity: 0;
            }
        }
        .entity-logo{
            height: 100%;
            width: auto;
        }
        .feed-info-container{
            font-size: 9px;
            line-height: 11px;
            text-transform: uppercase;
            flex-basis: 40%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            transition: opacity .5s;

            .feed-info{
                font-family: roboto;
                text-align: center;
            }
            .feed-data{

                font-family: roboto-thin;
                font-size: 90px;
                line-height: 105px;
                .feed-duration{
                    text-align: left;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Home/entity.vue